'use strict';

import { Report } from '../Report';

export interface ReportFilterOptionData {
  field: string;
  key: string | number;
}

export class ReportFilterOption extends Report {
  protected _data!: ReportFilterOptionData;

  constructor() {
    super();
  }

  static hydrate(data: ReportFilterOptionData): ReportFilterOption {
    const option = new ReportFilterOption();
    option._data = data;
    return option;
  }

  public getField(): string {
    return this._data.field;
  }

  public getKey(): string | number {
    return this._data.key;
  }
}
